import { X } from "lucide-react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../../../shared/ui";

type KybComplianceRejectCustomerModalProps = {
  open: boolean;
  reason: string;
  isSubmitting?: boolean;
  onOpenChange: (open: boolean) => void;
  onReasonChange: (reason: string) => void;
  onSubmit: () => void;
};

const KybComplianceRejectCustomerModal = ({
  open,
  reason,
  isSubmitting,
  onOpenChange,
  onReasonChange,
  onSubmit,
}: KybComplianceRejectCustomerModalProps) => {
  const canSubmit = Boolean(reason.trim()) && !isSubmitting;

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      overlayClassName="bg-black/75"
      contentClassName="max-w-[600px] bg-white"
    >
      <ModalHeader className="items-center aku-heading-h2-semibold">
        <ModalTitle>Reject customer?</ModalTitle>
        <button
          type="button"
          aria-label="Close modal"
          disabled={isSubmitting}
          onClick={() => onOpenChange(false)}
          className="rounded-full p-2 text-[#161827] hover:bg-[#F2F4FF] disabled:cursor-not-allowed disabled:opacity-50"
        >
          <X size={20} />
        </button>
      </ModalHeader>

      <ModalBody className="pt-4">
        <div
          id="kyb-reject-customer-reason-label"
          className="aku-body-small-medium text-[#2C2F44]"
        >
          Why are you rejecting this customer?
        </div>
        <textarea
          id="kyb-reject-customer-reason"
          aria-labelledby="kyb-reject-customer-reason-label"
          value={reason}
          maxLength={100}
          disabled={isSubmitting}
          onChange={(event) => onReasonChange(event.target.value)}
          placeholder="Enter reason"
          className="mt-2 min-h-[120px] w-full resize-none rounded-[14px] bg-[#EEF1FB] px-4 py-3 text-[14px] font-[350] text-gray-30 placeholder:text-gray-20 focus:outline-none focus:ring-2 focus:ring-[#D9DEFF] disabled:cursor-not-allowed disabled:opacity-60"
        />
        <div className="mt-2 text-right text-[14px] font-[350] text-[#383B56]">
          {reason.length}/100
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          type="button"
          disabled={!canSubmit}
          onClick={onSubmit}
          className="h-11 rounded-[14px] px-6 text-[16px] font-[500]"
        >
          {isSubmitting ? "Rejecting..." : "Reject"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default KybComplianceRejectCustomerModal;
